import { FileText, ReceiptText } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Modal } from '@/components/ui/modal'
import { printBordro } from '../../lib/bordroActions'
import type { BordroSatir } from '../../types'
import { BordroStatusPill } from '../StatusPill'
import { BordroSummaryBody } from './BordroSummaryBody'

export function BordroSummaryModal({ row, donem, onClose }: { row: BordroSatir; donem: string; onClose: () => void }) {
  const { t } = useTranslation()
  return (
    <Modal
      open
      onOpenChange={(v) => !v && onClose()}
      size="sm"
      icon={<ReceiptText />}
      title={`${row.ad} · ${t('hr.personel.bordro.ozet')}`}
      description={`${row.unvan} · ${row.departman} · ${t('hr.personel.fields.sicil')}: ${row.sicil} · ${donem}`}
      footer={
        <>
          <Button type="button" variant="cancel" onClick={onClose}>
            {t('common.close')}
          </Button>
          <Button type="button" onClick={() => void printBordro(row, donem)}>
            <FileText />
            {t('hr.personel.actions.bordro.pdf')}
          </Button>
        </>
      }
    >
      <div className="mb-4 flex items-center justify-between gap-2 text-sm">
        <span className="text-muted-foreground">{t('hr.personel.columns.durum')}</span>
        <BordroStatusPill durum={row.durum} />
      </div>
      <BordroSummaryBody row={row} />
    </Modal>
  )
}
